import { combineReducers } from 'redux';

import playersReducer from './players/store/reducer';
import sharedReducer from './shared/store/reducer';
import authorizationReducer from './shared/store/authSlice';
import compareReducer from './shared/store/compareSlice';
import conversationsReducer from './messages/store/conversationsSlice';
import checklistReducer from './checklist/store/checklistSlice';
import timeTrackingReducer from './timeTracking/store/timeTrackingSlice';
import adminConversationsReducer from './messages/store/adminConversationsSlice';
import adminOversightReducer from './messages/store/adminOversightSlice';

const rootReducer = combineReducers({
  players: playersReducer,
  shared: sharedReducer,
  authorization: authorizationReducer,
  compare: compareReducer,
  conversations: conversationsReducer,
  checklist: checklistReducer,
  timeTracking: timeTrackingReducer,
  adminConversations: adminConversationsReducer,
  adminOversight: adminOversightReducer,
});

export default rootReducer;
